import { format } from 'date-fns';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import ContentContainer from '../PageSections/ContentContainer';
import * as styles from './BlogPostHeader.module.scss';

export default function BlogPostHeader({ post }) {
  const postDate = format(new Date(post.publishDate), 'MMMM dd, yyyy');
  const category = post.categories?.[0]?.categoryName;

  return (
    <ContentContainer wide={true} data-analytics-section={'blog-post-header'}>
      <div className={styles.header}>
        <ContentfulImage
          lazy={false}
          priority={'high'}
          imageFragment={post.pageMetaData?.ogImage || post.heroImage}
          className={styles.hero}
          data-analytics-component={'blog-post-hero-image'}
        />
        <div
          className={styles.heroContent}
          data-analytics-component={'blog-post-header-copy'}
          data-analytics-id={post.title}
        >
          <span className={styles.meta}>
            {category} {category && post.readTime && <>·</>} {post.readTime}
          </span>
          <h1>{post.title}</h1>
          <div className={styles.author}>
            {post.subjectMatterExpert && (
              <img src="/images/expert-badge.svg" alt="Subject matter expert badge" className={styles.expertBadge} />
            )}
            <div className={styles.byline} style={post.subjectMatterExpert ? { textAlign: 'left' } : {}}>
              {post.author?.name}
              <div className={styles.date}>{postDate}</div>
            </div>
          </div>
        </div>
      </div>
      {post.lede?.lede && <p className={styles.lede}>{post.lede.lede}</p>}
    </ContentContainer>
  );
}
